import { render, staticRenderFns } from "./ExcluirAtivo.vue?vue&type=template&id=19a8bbe6&scoped=true&"
import script from "./ExcluirAtivo.vue?vue&type=script&lang=js&"
export * from "./ExcluirAtivo.vue?vue&type=script&lang=js&"
import style0 from "./ExcluirAtivo.vue?vue&type=style&index=0&id=19a8bbe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8bbe6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VForm,VImg,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a8bbe6')) {
      api.createRecord('19a8bbe6', component.options)
    } else {
      api.reload('19a8bbe6', component.options)
    }
    module.hot.accept("./ExcluirAtivo.vue?vue&type=template&id=19a8bbe6&scoped=true&", function () {
      api.rerender('19a8bbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/actions/ExcluirAtivo.vue"
export default component.exports